import * as urls from "./url";
import client, { getHeader } from "../client";
import { interceptor, substituteEncrypted } from "../../util/util";

export const getCaseListCall = async (requestBody) => interceptor(async () => client.post(urls.getCaseList(), await substituteEncrypted(requestBody), getHeader()));

export const getClosedCaseListCall = async (requestBody) =>
  interceptor(async () => client.post(urls.getClosedCaseList(), await substituteEncrypted(requestBody), getHeader()));

export const getCaseStatusCall = async () => interceptor(async () => client.get(urls.getCaseStatus(), getHeader()));

export const getCaseTypeCall = async (requestBody) => interceptor(async () => client.post(urls.getCaseType(), requestBody, getHeader()));

export const getCaseSpecificTypeCall = async (requestBody) => interceptor(async () => client.post(urls.getCaseSpecificType(), requestBody, getHeader()));

export const getActivityCall = async (requestBody) =>
  interceptor(async () => client.post(urls.getActivity(), await substituteEncrypted(requestBody), getHeader()));

export const closeCaseCall = async (requestBody) => interceptor(async () => client.post(urls.closeCase(), await substituteEncrypted(requestBody), getHeader()));

export const createCaseCall = async (requestBody) => interceptor(async () => client.post(urls.createNewCase(), await substituteEncrypted(requestBody), getHeader()));

export const postAnAttachmentCall = async (postData) =>
  interceptor(async () => client.post(urls.postNewAttachment, await substituteEncrypted(postData), getHeader()));

export const getCaseDetailsCall = async (requestBody) =>
  interceptor(async () => client.post(urls.getCaseDetails(), await substituteEncrypted(requestBody), getHeader()));

export const getViewAttachmentCall = async (docId) => interceptor(async () => client.post(urls.getAttachment, docId, getHeader()));

export const addCommentCall = async (requestBody) => interceptor(async () => client.post(urls.createComment(), await substituteEncrypted(requestBody), getHeader()));
